export enum OrderBookingHealthCheckTab {
  AllBookings = 0,
  AssignedToYou = 1,
  AssignedToOthers = 2,
  Unassigned = 3,
}

export enum OrderBookingIssueStatus {
  Open = 0,
  Resolved = 1,
  Dismissed = 2,
}

export enum OrderBookingIssueClosureReason {
  Corrected = 1,
  Dismissed = 2,
  NoLongerCorrectable = 3,
}

export enum OrderBookingIssueProgress {
  NoIssues = 0,
  Open = 1,
  PartiallyClosed = 2,
  Resolved = 3,
  Dismissed = 4,
}

export enum OrderBookingCheckType {
  IncompleteCollectionAddress = 1,
  IncompleteDeliveryAddress = 2,
  MissingCollectionContact = 3,
  MissingDeliveryContact = 4,
  MissingVehicleModel = 5,
  MissingMoDelPin = 6,
  CollectionOutsideOpeningHours = 7,
  DeliveryOutsideOpeningHours = 8,
  ExchangeNotSameWorkingDay = 9,
  CollectionBeforeEarliestTime = 10,
  DeliveryBeforeEarliestTime = 11,
  CollectionAfterLatestTime = 12,
  DeliveryAfterLatestTime = 13,
}

export const ORDER_BOOKING_ISSUE_STATUS_LABELS: Record<OrderBookingIssueStatus, string> = {
  [OrderBookingIssueStatus.Open]: 'Open',
  [OrderBookingIssueStatus.Resolved]: 'Resolved',
  [OrderBookingIssueStatus.Dismissed]: 'Dismissed',
};
